import { render } from "./PropertyAttachments.vue?vue&type=template&id=0e3a99ee"
import script from "./PropertyAttachments.vue?vue&type=script&lang=js"
export * from "./PropertyAttachments.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__